var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"k2Pdf"},[_c('vue-pdf-embed',{ref:"pdfRef",attrs:{"source":_vm.source,"page":_vm.page},on:{"rendered":_vm.handleDocumentRender}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }